import React from 'react';
import './News.css';
import NewsletterSubscriptionForm from './NewsletterSubscriptionForm';

const Subscribe = () => {
  return (
    <div id="news" className="small-12 large-12 columns">
      <div className="panel">
      <h4 className="modal-title">Join our newsletter</h4>
      <p>Subscribe to our newsletter with your email and get notified of new releases and important announcements.</p>
        <NewsletterSubscriptionForm />
      </div>
    </div>
  )
}

export default Subscribe
